<template>
  <span v-if="placement.mode === 'all'" class="sat-chip _accent placement-badge" :title="$t('satellites.placement.all')">
    <SatIcon name="globe" :size="12" />
    {{ $t("satellites.placement.all_short") }}
  </span>
  <span v-else-if="!targets.length" class="sat-chip _warn placement-badge">
    <SatIcon name="alert" :size="12" />
    {{ $t("satellites.placement.nowhere") }}
  </span>
  <span v-else class="sat-chip placement-badge" :title="targets.join(', ')">
    <SatIcon :name="placement.groups.length ? 'layers' : 'server'" :size="12" />
    <span class="placement-badge__text">{{ targets.slice(0, 2).join(", ") }}</span>
    <span v-if="targets.length > 2" class="placement-badge__more">+{{ targets.length - 2 }}</span>
  </span>
</template>
<script>
import SatIcon from "@/components/Satellites/SatIcon.vue";
import { satelliteName } from "@/components/Satellites/format";

// Compact view of a domain placement: { mode, groups: [{ id, name }], satellites: [{ id, name, hostname }] }.
export default {
  name: "PlacementBadge",
  components: { SatIcon },
  props: {
    placement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    targets() {
      return [...this.placement.groups.map((group) => group.name), ...this.placement.satellites.map((satellite) => satelliteName(this, satellite))];
    },
  },
};
</script>
<style lang="scss" scoped>
.placement-badge {
  max-width: 240px;
}

.placement-badge__text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.placement-badge__more {
  color: var(--sat-muted);
}
</style>
